import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Client } from '../../events/models/client.model';
import { ApiResponse } from '../../models/api.model';

export type GeneralSettingsClientPatch = Partial<
  Pick<
    Client,
    | 'defaultBuyerTypeId'
    | 'defaultBuyerTypeName'
    | 'regularHoldCodes'
    | 'adaHoldCodes'
    | 'minTickets'
    | 'maxTickets'
    | 'isFeeFromPv'
  >
>;

@Injectable({
  providedIn: 'root',
})
export class ClientSettingsService {
  private http = inject(HttpClient);

  public get$(id: number): Observable<ApiResponse<Client>> {
    return this.http.get<ApiResponse<Client>>(
      `${environment.apiURl}/bo/clients/${id}`
    );
  }

  public patch$(
    id: number,
    body: GeneralSettingsClientPatch
  ): Observable<ApiResponse<Client>> {
    return this.http.patch<ApiResponse<Client>>(
      `${environment.apiURl}/bo/clients/${id}`,
      body
    );
  }
}
